import MsgAlert from "Admin/components/MsgAlert";
import SubmitButton from "Admin/components/SubmitButton";
import React, { useState, useEffect } from "react";
import { GenPost, GenGet } from "state/api";

const UpdateProduto = ({pointer}) => {
  const [postLoading, setPostLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [formData, setFormData] = useState({
    codigo: "",
    nome: "",
    preco_venda: "",
    status: true,
    custo: 0,
    liquido: 0,
    unidade_medida: "",
    estoque_minimo: "",
    estoque_atual: "",
    controla_estoque: false,
    previsao_retorno: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GenGet(`/servprod/${pointer}`);
        setFormData(response);
      } catch (err) {
        setMsg(err.message);
        setTimeout(() => setMsg(null), 3000);
      }
    };

    fetchData();
  }, [pointer]);

  const handlePost = async () => {
    const requiredFields = ['nome', 'preco_venda'];
    for (const field of requiredFields) {
      if (!formData[field]) {
        setMsg(`O campo "${field}" é obrigatório`);
        setTimeout(() => setMsg(null), 3000);
        return;
      }
    }

    try {
      setPostLoading(true);
      const payload = { ...formData };
      const response = await GenPost(`/updateservprod/${pointer}`, payload);
      
      setMsg(response.message);
      setTimeout(() => setMsg(null), 3000);
      setPostLoading(false);
    } catch (err) {
      setMsg(err.message);
      setTimeout(() => setMsg(null), 3000);
      setPostLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  return (
    <div className="flex flex-col w-full p-2 text-[10pt] h-full bg-slate-100 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold mb-4">Atualização de Produto</h2>
      <p className="text-gray-600 mb-6">Atualize as informações do produto</p>

      {formData && (    
        <div className="space-y-4">
        {/* Informações Gerais */}
        <h3 className="text-lg font-semibold border-b pb-2">Informações Gerais</h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

          <label className="block">
            <span className="text-gray-700">Nome:<span className="text-red-600">*</span></span>
            <input type="text" name="nome" required value={formData.nome} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md" />
          </label>

          <label className="block">
            <span className="text-gray-700">Preço de Venda:<span className="text-red-600">*</span></span>
            <input min={'0'} type="number" name="preco_venda" step="0.01" required value={formData.preco_venda} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md" />
          </label>

          <div className="flex items-center space-x-2">
            <span className="text-gray-700 font-semibold">Ativo</span>
            <div 
                onClick={() => handleChange({ target: { name: 'status', value: !formData.status }})}
                className={`relative w-12 h-6 rounded-full p-1 cursor-pointer transition-colors ${
                formData.status ? "bg-green-500" : "bg-gray-300" }`} >
                    <div className={`absolute w-4 h-4 bg-white rounded-full shadow-md transform transition-transform ${
                        formData.status ? "translate-x-6" : "translate-x-0" }`} />
            </div>
          </div>

        </div>

        {/* Especificações e Detalhes */}
        <h3 className="text-lg font-semibold border-b pb-2">Especificações e Detalhes</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label className="block">
            <span className="text-gray-700">Custo:</span>
            <input min={'0'} type="number" name="custo" step="0.01" value={formData.custo} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md" />
          </label>
        </div>

        {/* Especificações de Produtos */}
        <h3 className="text-lg font-semibold border-b pb-2">Especificações de Produtos</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="block">
                <span className="text-gray-700">Unidade de Medida:</span>
                <input type="text" name="unidade_medida" value={formData.unidade_medida} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md" />
              </label>

              <label className="block">
                <span className="text-gray-700">Estoque Mínimo:</span>
                <input min={'0'} type="number" name="estoque_minimo" value={formData.estoque_minimo} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md" />
              </label>

              <label className="block">
                <span className="text-gray-700">Estoque Atual:</span>
                <input min={'0'} type="number" name="estoque_atual" value={formData.estoque_atual} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md" />
              </label>
          </div>


          <div className="flex items-center space-x-2">
            <span className="text-gray-700 font-semibold">Controla Estoque?</span>
            <div 
                onClick={() => handleChange({ target: { name: 'controla_estoque', value: !formData.controla_estoque }})}
                className={`relative w-12 h-6 rounded-full p-1 cursor-pointer transition-colors ${
                formData.controla_estoque ? "bg-green-500" : "bg-gray-300" }`} >
                    <div className={`absolute w-4 h-4 bg-white rounded-full shadow-md transform transition-transform ${
                        formData.controla_estoque ? "translate-x-6" : "translate-x-0" }`} />
            </div>
          </div>

        {/* Botão de envio */}
        <SubmitButton loading={postLoading} onClick={handlePost} label={"Atualizar"} />
        <MsgAlert alert={msg} />
      </div>
      )}

    </div>
  );
};

export default UpdateProduto;